import { render, staticRenderFns } from "./RemoteConnectionEdit.vue?vue&type=template&id=0201af44&"
import script from "./RemoteConnectionEdit.vue?vue&type=script&lang=ts&"
export * from "./RemoteConnectionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports